import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import { pathFor } from "../../i18n/routes";
import "./NotFound.css";

// Netlify serves one static 404.html (prerendered by react-snap) for every
// unknown URL, French or English, with a 404 status: the page shows both
// languages and is never indexed.
const TEXTS = [
  {
    lang: "fr",
    title: "Page introuvable",
    text: "Cette page n'existe pas ou a été déplacée.",
    link: "Voir les outils gratuits",
  },
  {
    lang: "en",
    title: "Page not found",
    text: "This page does not exist or has moved.",
    link: "See the free tools",
  },
];

const NotFound = () => (
  <section className="not-found">
    <Helmet>
      <title>Page introuvable · Page not found | Localranker</title>
      <meta name="robots" content="noindex" />
    </Helmet>
    <p className="not-found__code">404</p>
    <div className="not-found__langs">
      {TEXTS.map((t) => (
        <div key={t.lang} lang={t.lang} className="not-found__lang">
          <h2 className="not-found__title">{t.title}</h2>
          <p className="not-found__text">{t.text}</p>
          <Link className="btn btn--primary" to={pathFor("home", t.lang)}>
            {t.link}
          </Link>
        </div>
      ))}
    </div>
  </section>
);

export default NotFound;
